import { Box, BoxProps, theme } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

const NAV_COLLAPSE_BREAKPOINT = theme.breakpoints[2];
const WHEN_NAV_NOT_COLLAPSED = `@media screen and (min-width: ${NAV_COLLAPSE_BREAKPOINT})`;
const NAV_SIDEBAR_WIDTH = '220px';

export const LayoutContainer = styled('div')`
  display: grid;
  height: 100%;
  min-height: 100vh;
  grid-template-columns: minmax(320px, 100vw);
  grid-template-rows: ${theme.space[11]} 1fr;

  ${WHEN_NAV_NOT_COLLAPSED} {
    grid-template-columns: ${NAV_SIDEBAR_WIDTH} 1fr;
    grid-template-rows: 100vh;
  }
`;

export const Nav = styled('div')`
  grid-row-start: 1;
  grid-column-start: 1;
`;

export const Main = styled(({ as = 'main', ...props }: BoxProps) => <Box as={as} {...props} />)`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  grid-row-start: 2;
  grid-column-start: 1;

  ${WHEN_NAV_NOT_COLLAPSED} {
    overflow: auto;
    grid-row-start: 1;
    grid-column-start: 2;
    -webkit-overflow-scrolling: touch;
  }
`;

export const Content = styled('div')`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
`;
